fragment FullwidthTopicFeatureBarsFragment on fullwidthTopicFeatureBars_Entry {
  typeHandle
  image {
    url
    title
  }
  alt
  heading
  topic {
    uri
  }
  position
}
